import Game from "./Game";
import { createCharacterAnims } from "../anims/CharacterAnims";
import "../characters/MyPlayer";
import "../characters/OtherPlayer";
import OtherPlayer from "../characters/OtherPlayer";
import PlayerSelector from "../characters/PlayerSelector";
import Network from "../services/Network";
import store from "../state";
import { setLevel } from "../state/ChatStore";
import { MAP_CONTENT_KEYS } from "../constants/map-content-keys";
import { MAPS } from "../constants/maps";
import { Levels } from "../constants/levels";
import { SCENES } from "../constants/scenes";
import { removeIdList, setLocationz, setPlayerX, setPlayerY } from "../state/UserStore";

export default class FourthLevel extends Game {
  constructor() {
    super(SCENES.FOURTH_LEVEL, MAPS.fourthLevel.key);
  }

  protected init(data: any) {
    this.createLayer(data);
    this.physics.world.setBounds(0, 0, this.map.widthInPixels, this.map.heightInPixels);

    const levelCenterLounge = this.map.objects.find((o) => o.name === MAP_CONTENT_KEYS.objects.ZONES_LOUNGE);
    if (levelCenterLounge) {
      levelCenterLounge.objects.map((o: any) => {
        const zone = this.add.zone(o.x, o.y, o.width, o.height);
        this.physics.add.existing(zone);
        this.physics.add.overlap(zone, this.playerSelector, () => {
          store.dispatch(setPlayerX(1000));
          store.dispatch(setPlayerY(10400));
          this.scene.start(o.properties[1].value, {
            comesFrom: this.scene.key,
            network: this.network,
          });
        });
      });
    }

    const levelLeftEngineeringBay = this.map.objects.find((o) => o.name === MAP_CONTENT_KEYS.objects.ZONES_ENGINEERING_BAY);
    if (levelLeftEngineeringBay) {
      levelLeftEngineeringBay.objects.map((o: any) => {
        const zone = this.add.zone(o.x, o.y, o.width, o.height);
        this.physics.add.existing(zone);
        this.physics.add.overlap(zone, this.playerSelector, () => {
          this.scene.start(o.properties[1].value, {
            comesFrom: this.scene.key,
            network: this.network,
          });
        });
      });
    }

    // this.createAudio();
    this.initCamera();
    this.registerKeys();
  }

  createLayer(data: { network: Network }) {
    if (!data.network) {
      throw new Error("server instance missing");
    } else {
      this.network = data.network;
    }

    createCharacterAnims(this.anims);

    this.map = this.make.tilemap({ key: this.mapKey });
    store.dispatch(setLevel(SCENES.FOURTH_LEVEL));
    store.dispatch(removeIdList());

    store.dispatch(setLocationz(2));

    const dataState = store.getState().userGame;
    this.myPlayer = this.add.myPlayer(
      dataState.playerX ? dataState.playerX : 18500,
      dataState.playerY ? dataState.playerY : 4300,
      dataState.textureName ? dataState.textureName : "male",
      this.network.mySessionId
    );

    Levels.fourthLevel.layers.map((layer) => {
      const tilesetImage = this.map.addTilesetImage(layer.tilesetImage.tilesetName, layer.tilesetImage.tilesetKey);

      const newLayer = this.map.createLayer(layer.layerName, tilesetImage);
      newLayer.setCollisionByProperty({ collides: layer.collision });
      this.physics.add.collider([this.myPlayer, this.myPlayer.playerContainer], newLayer);
    });

    this.playerSelector = new PlayerSelector(this, 0, 0, 256, 512);

    // don't go out of the map
    this.physics.world.bounds.width = this.map.widthInPixels;
    this.physics.world.bounds.height = this.map.heightInPixels;
    this.myPlayer.setCollideWorldBounds(true);

    // import other objects from Tiled map to Phaser -> use object
    Levels.fourthLevel.tiles.map((tile) => {
      this.addGroupFromTiled(tile.objectLayerName, tile.key, tile.tilesetName, tile.collidable);
    });

    this.otherPlayers = this.physics.add.group({ classType: OtherPlayer });
    for (const key in store.getState().userGame.playerLocMap) {
      console.log(store.getState().userGame.playerLocMap[key], "LOG");
      if (store.getState().userGame.playerLocMap[key].locationz == store.getState().userGame.locationz) {
        const otherPlayer = this.add.otherPlayer(
          store.getState().userGame.playerLocMap[key].x,
          store.getState().userGame.playerLocMap[key].y,
          store.getState().userGame.playerLocMap[key].anim.split("_")[0] ? store.getState().userGame.playerLocMap[key].anim.split("_")[0] : "male",
          store.getState().userGame.playerLocMap[key].id,
          store.getState().userGame.playerLocMap[key].name
        );
        this.otherPlayers.add(otherPlayer);
        this.otherPlayerMap.set(store.getState().userGame.playerLocMap[key].id, otherPlayer);
      }
    }
    this.physics.add.overlap(this.myPlayer, this.otherPlayers, this.handlePlayersOverlap, undefined, this);

    // register network event listeners
    this.network.onPlayerJoinedScene4(this.handlePlayerJoined, this);
    this.network.onPlayerLeft(this.handlePlayerLeft, this);
    this.network.onMyPlayerReady(this.handleMyPlayerReady, this);
    this.network.onMyPlayerVideoConnected(this.handleMyVideoConnected, this);
    this.network.onPlayerUpdated4(this.handlePlayerUpdated, this);
    this.network.onItemUserAdded(this.handleItemUserAdded, this);
    this.network.onItemUserRemoved(this.handleItemUserRemoved, this);
    this.network.onChatMessageAdded(this.handleChatMessageAdded, this);
  }
}
